import React from "react";
import UserPurchaseAccountsComp from "../../components/User/UserPurchaseAccounts";

export default function UserPurchaseAccountsPage() {
  return <UserPurchaseAccountsComp />;
}
